import { Component, type ErrorInfo, type ReactNode } from 'react'
import i18n from '@/i18n.config'

interface State { hasError: boolean }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('App error:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-md bg-bg p-lg text-center">
          <h1 className="text-h3 font-bold text-text">{i18n.t('common.error', 'Something went wrong')}</h1>
          <p className="max-w-sm text-body text-text-secondary">{i18n.t('webapp.log.error', 'Something went wrong. Please try again.')}</p>
          <button onClick={() => window.location.reload()} className="rounded-md bg-primary px-md py-sm text-button font-semibold text-white hover:opacity-90">
            {i18n.t('webapp.retry', 'Retry')}
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
